import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Keys} from '../../model/constants';
import * as Immutable from 'immutable';
import {SelectionModes, isSelectionVisible} from './editor/SelectionManager';
import {appendEditableCell} from "./TableUtils";
import {defaultComparator} from "../../utils";

const colProperties = Immutable.OrderedMap({
    'id':(prop) => prop,
    'publishDate':(prop) => prop?prop.format():'-',
    'views':(prop) => prop?prop.size:0,
    'displays':(prop) => prop?prop.size:0,
    'category':(prop) => prop?prop:'-',
    'customer':(prop) => prop?prop:'-',
    'assigneeId':(prop) => prop?prop:'unassigned',
    'displayCount':(prop) => prop,
    'ghostCount':(prop) => prop,
    'src':(prop) => prop,
});

class ItemLstTable extends React.Component {


    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.hasWorkSesion =  !props.currentWorkSession.isEmpty();
    }

    componentWillReceiveProps(nextProps) {
        this.hasWorkSesion = nextProps.currentWorkSession && !nextProps.currentWorkSession.isEmpty()

    }
    getHeaderColumns() {
        const colNames = colProperties.keySeq().toArray();
        colNames.unshift("Hidden")
        if( this.hasWorkSesion) {
            colNames.unshift("W")
        }
        let i = 0;
        return colNames.map(c => <th key={i++}>{c}</th>)
    }


    getItemColumns(item) {

        const mutation = this.props.mutations.getIn([Keys.MutationType.ITEM, item.get(Keys.ID) ], null);


        const columnContent = colProperties.map((fn, p) => {
                return {
                    className:'',
                    value:fn(item.get(p, null))
                }
            }).toArray();

        columnContent.unshift(appendEditableCell('item-lst__work-session-cell', item, mutation, Keys.Item.HIDDEN, 'H'));
        if( this.hasWorkSesion) {
            columnContent.unshift(appendEditableCell('item-lst__work-session-cell', item, mutation, Keys.Item.IN_WORK_SESSION, 'W'));
        }
        let i = 0;
        return columnContent.map(c => <td className={c.className} key={i++}>{c.value}</td>)

    }
    getItemRows() {
        const {state, recordOrder, selectedItems, lastItemClicked, mode} = this.props.selectionInfo;
        const selectionVisible = isSelectionVisible(state);
        const rows = this.props.items.valueSeq().sort((a,b) => defaultComparator(Number(a.get(Keys.ID)), Number(b.get(Keys.ID)))).map(
            item => {
                recordOrder(item,  Keys.MutationType.ITEM);
                let selected = selectedItems.contains(item);
                let lastSelected = (item === lastItemClicked); // NOTE: if we filter this item out, the range selection will start from the same item
                let classNames = ['item-lst__row'];
                if( selected&&selectionVisible) {
                    classNames.push('item-lst__row--selected');
                }
                if ( lastSelected&&mode!==SelectionModes.TOGGLE&&selectionVisible) {
                    classNames.push('item-lst__row--last-clicked');
                }
                const columns = this.getItemColumns(item);
                const id = item.get(Keys.ID);
                return (<tr
                    key={id}
                    data-item-id={id} // so that we can find our items in the click handler
                    className={classNames.join(" ")}
                    onClickCapture={this.handleClick}
                >{columns}</tr>)
            }
        );
        return rows;
    }
    handleClick(event) {
        const id = event.currentTarget.getAttribute('data-item-id');
        const item = this.props.items.get(id);
        if ( item) {
            this.props.selectionInfo.handleClick(item, Keys.MutationType.ITEM);
        } else {
            console.warn("handleClick: couldn't find item with id: "+id);
        }
    }

    render() {
        return (
            <div>
                <table height="800" className="item-lst__table noselect">
                    <thead>
                    <tr>
                        {this.getHeaderColumns()}
                    </tr>
                    </thead>
                    <tbody>
                    { this.getItemRows()}
                    </tbody>
                </table>
            </div>

        )
    }
}

ItemLstTable.propTypes = {
    selectionInfo:React.PropTypes.object,
    items:ImmutablePropTypes.map.isRequired,
    currentWorkSession:ImmutablePropTypes.map.isRequired,
};


export default ItemLstTable



// WEBPACK FOOTER //
// ./src/ui/components/ItemLstTable.js